import React, { useState } from 'react';

import './ProfilePage.css';

import ReviewNew from '../compObjects/ReviewNew';
import ReviewExisting from '../compObjects/ReviewExisting';

import Profile from '../compObjects/Profile';
import Spinner from '../compUtils/Spinner';

import { useDispatch } from 'react-redux'
import { useObjectSelector, getObject } from '../redux/hooks'

import { useSelector } from 'react-redux'

import LazyLoad from 'react-lazyload';
import Icon from '../compUtils/Icon';



import {
  useParams,
} from "react-router-dom";

function ProfilePage(props) {

  let { id } = useParams();

  const dispatch = useDispatch()

  const reviewsObjectId = "/api/reviews/?param=" + encodeURI(JSON.stringify({ "filter": { "field": "profile", "value": id }, "order_by": "-date" }))
  const reviewsSelector = useObjectSelector(reviewsObjectId)
  const reviews = getObject(reviewsObjectId, reviewsSelector, dispatch)

  const loginState = useSelector(store => store.loginReducer)

  const [createState, setCreateState] = useState('NOCREATE' ) //CREATEPENDING, CREATEEDIT ; 

  return (

    <div class="columns is-variable is-8" >
      <div class="column is-one-quarter">
        <Profile profileId={id} />
      </div>


      {
        reviews() === "UNKNOWN"
          ?
          <Spinner />
          :
          <div class="column">

            {loginState.logged && loginState.profile.id === parseInt(id) ?
            createState === "CREATEPENDING" ?
            "saving..." //JE CROIS QUE CA SERT A RIEN. EN TOUT CAS Y'A LE MEME DANS LE REVIEW
            :
            createState === "CREATEEDIT" ?
            <ReviewNew profile={parseInt(id)} type={"MOVIE"} setCreateState={setCreateState} createState={createState} reviewsObjectId={reviewsObjectId}  />
            :
              <div class="box tile">
                <a class="okwButton" onClick={()=>{setCreateState('CREATEEDIT' )}}>
                  <Icon name="plus" />
                </a></div> : ""}

            {reviews().map((review) => (
              <LazyLoad height={200}>
                <ReviewExisting reviewId={review.id}  type={"MOVIE"} />
              </LazyLoad>
            ))}

          </div>
      }


    </div>
  );
}

export default ProfilePage;
